// ############################ Require packages here ############################
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Table } from 'react-bootstrap';

// ############################ Require files here ###############################

import './resources.scss';
import ScheduleForm from '../scheduleForm';
import RelatedResources from '../relatedResources';
import ShareUrl from './shareUrl';

export default function Blogs36() {

    const navigate = useNavigate();
    return (
        <div className='seq-reports-view'  >
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <title>Analysis of a Remote Access Trojan</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="Discover how RATs work in malware and protect against threats with expert insights." />
                <meta name="keywords" content="malware, malware research, RAT, trojan, APT, exfiltration, threat intel, CTI, GTI, central threat intelligence, nation-state attack, threat actor, tactics techniques and procedures, MITRE ATT&CK, TTPs, remote code execution" />
                <meta property="og:title" content="In-Depth Guide to Remote Access Trojans" />
                <meta property="og:description" content="Discover how RATs work in malware and protect against threats with expert insights." />
            </Helmet>
            {/* section 1 BANNER */}
            <div className='container contain-width'>
                <div className='breadcrumb pe-0 ps-0'>
                    <ul>
                        <li><span onClick={() => navigate('/resources-hub')}>Resources</span>
                            <span onClick={() => navigate('/resources-hub', { state: { type: 'blog' } })}>{' > '} Blogs</span>
                            <span>{' > '}Analysis of a Remote Access Trojan</span>
                        </li>
                    </ul>
                </div>
                {/* section 2 DISCRIPTION */}
                <div className='seq-report-view'>
                    <div className='blog-div'>
                        <h3>Analysis of a Remote Access Trojan</h3>
                        <p>18-JUNE-2025 | Sequretek Research Labs</p>
                        <div className='blog-body'>
                            <img src='/images/blog-images/blog36.jpg' width={'100%'} height={465} alt='' />
                            
                            <h4>Overview</h4>
                            <p>Sequretek Labs analyzed an interesting ELF sample linked to recent activity by a nation-state APT group. The malware was built using PyInstaller to bundle a Python-based payload and exhibited behavior consistent with targeted data theft. Upon execution, it copied itself to a hidden directory under a different name, enhancing its stealth and persistence. It then attempted to connect to an attacker-controlled C2 server, signaling its intent to exfiltrate files and receive remote commands from the threat actor infrastructure.</p>

                            <h4>Initial Findings</h4>
                            <p>Sequretek Labs observed on its news feed reports related to recent activity by the nation-state APT groups, specifically referencing the SideCopy campaign and its use of the Python-based Ares RAT targeting Indian government entities. One of the indicators shared in the news feed included a C2 IP address (167[.]86[.]97[.]58:17854).</p>< br/>

                            <img src='/images/blog-images/blog36-1.png' width={'100%'} height={340} alt='' />
                            <p className='text-center'>Figure 1: Initial sample details</p>

                            <p>Upon investigation, our team searched for the IP within Sequretek’s internal threat intelligence portal and discovered it was previously observed in connection with an ELF binary captured by our Global Threat Detection Network.</p>

                            <img src='/images/blog-images/blog36-2.png' width={'100%'} height={230} alt='' />
                            <p className='text-center'>Figure 2: Initial sample details</p>

                            <p>This finding triggered a detailed investigation of the ELF sample, leading to a thorough analysis of its execution behavior and command-and-control mechanisms.</p>
                            <p>The binary was identified as a Remote Access Trojan (RAT). On execution, it immediately concealed itself by copying the payload into hidden directories under alternate names. It then deployed required dependencies and executed a Python-based payload in a temporary location via a child process. The malware removed its source files post-launch, enabling it to operate covertly and avoid disk-based detection. It established persistence and connected to a C2 server, exfiltrating system metadata. Using specific API endpoints (/hello, /report, /upload), it maintained active communication with the attacker’s infrastructure and enabled remote command execution capabilities.</p>

                            <p><strong>File Details:</strong></p>

                            <Table responsive>
                                <tr>
                                    <th><p><strong>Parameter</strong></p></th>
                                    <th><p><strong>Indicator</strong></p></th>
                                </tr>
                                <tr>
                                    <th><p>MD5</p></th>
                                    <th><p>0a1ea0e7119e125141792f24eceb62d2</p></th>
                                </tr>
                                <tr>
                                    <th><p>SHA1</p></th>
                                    <th><p>6b0ed151d80c019d9be3a28b6d84cfe723156f9f</p></th>
                                </tr>
                                <tr>
                                    <th><p>SHA256</p></th>
                                    <th><p>7129ad4ac19f03d6512d8ea3a4cf3373c52d30a982e4a3bba2a5357bcbdf7314</p></th>
                                </tr>
                                <tr>
                                    <th><p>File Type</p></th>
                                    <th><p>ELF 64-bit LSB executable</p></th>
                                </tr>
                                <tr>
                                    <th><p>Target Machine</p></th>
                                    <th><p>64-Bit</p></th>
                                </tr>
                                <tr>
                                    <th><p>File Size</p></th>
                                    <th><p>6.1 MB ( bytes)</p></th>
                                </tr>
                                <tr>
                                    <th><p>Signature</p></th>
                                    <th><p>Not signed</p></th>
                                </tr>
                                <tr>
                                    <th><p>Language</p></th>
                                    <th><p>Python</p></th>
                                </tr>
                                <tr>
                                    <th><p>Complier / Interpreter Version</p></th>
                                    <th><p>Python 2.7</p></th>
                                </tr>
                                <tr>
                                    <th><p>Packaged</p></th>
                                    <th><p>PyInstaller</p></th>
                                </tr>
                            </Table>

                            <h4>Techincal Analysis</h4>
                            <ol>
                                <li><p>Initial Execution</p></li>
                                <p>The binary displays a console message indicating the installation of an agent (Figure 3). It then copies itself to a concealed directory ~/.consieo, aiding in stealth and persistence.</p>

                                <img src='/images/blog-images/blog36-3.png' width={'100%'} height={260} alt='' />
                                <p className='text-center'>Figure 3: Initial sample execution</p>

                                <li><p>Dependency Setup</p></li>
                                <p>The malware downloads dependencies to a dynamically generated /tmp directory (e.g., /tmp/_MEItKeGL7) – a method commonly used by PyInstaller-packed Python malware (Figure 4).</p>

                                <p><strong>Key dropped files:</strong></p>
                                <ul>
                                    <li><p>_ssl.so, libssl.so, libcrypto.so: Enable encrypted communication.</p></li>
                                    <li><p>_json.so, _hashlib.so: Facilitate JSON parsing and hashing.</p></li>
                                    <li><p>libpython2.7.so.1.0: Embedded Python runtime.</p></li>
                                </ul>

                                <p>These files are loaded from /tmp, allowing the RAT to function even on systems lacking Python.</p>

                                <img src='/images/blog-images/blog36-4.png' width={'100%'} height={140} alt='' />
                                <p className='text-center'>Figure 4: List of dropped files in /tmp directory</p>

                                <li><p>Dynamic Directory Generation</p></li>
                                <p>A function generates the random name for the temporary directory (e.g., _MEItKeGL7) using a six-character random suffix (Figure 5).</p>

                                <img src='/images/blog-images/blog36-5.png' width={'100%'} height={230} alt='' />
                                <p className='text-center'>Figure 5: Function responsible for generating random names</p>

                                <li><p>The malware attempts to establish a connection to the hardcoded C2 server at 167[.]86[.]97[.]58:17854 (Figure 3). Since the live server was offline, a local C2 simulator was deployed to analyze communication patterns.</p></li>
                                <p>C2 Simulation Setup. To redirect RAT traffic locally, iptables was used:</p>

                                <ul>
                                    <li><p>sudo iptables -t nat -A OUTPUT -p tcp -d 167[.]86[.]97[.]58 --dport 17854 -j DNAT --to-destination 127[.]0[.]0[.]1:17854</p></li>
                                </ul>

                                <img src='/images/blog-images/blog36-6.png' width={'100%'} height={260} alt='' />
                                <p className='text-center'>Figure6: Captures the RAT’s console after redirection</p>

                                <p>Upon initiating communication with the C2 server, the malware first generates a unique URL to identify the infected system, as shown in Figure 7.</p>

                                <img src='/images/blog-images/blog36-7.png' width={'100%'} height={280} alt='' />
                                <p className='text-center'>Figure 7: C2 simulator in action</p>

                                <p>The communication begins with an initial request to the /hello endpoint, where the malware transmits basic information about the infected host, as illustrated in Figure 8.</p>

                                <img src='/images/blog-images/blog36-8.png' width={'100%'} height={200} alt='' />
                                <p className='text-center'>Figure 8: Initial C2 communication</p>

                                <p>Any response received from the C2 server via the /report endpoint is executed directly in the shell of the victim machine, with the output returned in the subsequent request to the same endpoint. This behavior was confirmed when a test command (fake) was sent, resulting in the response: sh: fake: command not found. A valid command (ps -aux) produced a successful output, as shown in Figure 9, with the corresponding C2 server interaction captured in Figure 10.</p>

                                <img src='/images/blog-images/blog36-9.png' width={'100%'} height={300} alt='' />
                                <p className='text-center'>Figure 9: Remote command execution</p>

                                <img src='/images/blog-images/blog36-10.png' width={'100%'} height={340} alt='' />
                                <p className='text-center'>Figure 10: Request captured by C2 server simulator</p>

                                <p>Subsequently, the RAT’s Remote Code Execution (RCE) capability was tested by attempting to launch the calculator application via the local C2 server simulator. The command execution is shown in Figure 11, with the resulting action depicted in Figure 12.</p>

                                <img src='/images/blog-images/blog36-11.png' width={'100%'} height={220} alt='' />
                                <p className='text-center'>Figure 11: Remote command execution</p>< br/>

                                <img src='/images/blog-images/blog36-12.png' width={'100%'} height={300} alt='' />
                                <p className='text-center'>Figure 12: Executed command to open Calculator</p>

                                <li><p>File Exfiltration</p></li>
                                <p>The /upload endpoint is used to exfiltrate data from /home/user/*. Confirmation and details of the upload are sent in a follow-up /report request (Figure 13).</p>

                                <img src='/images/blog-images/blog36-13.png' width={'100%'} height={220} alt='' />
                                <p className='text-center'>Figure 13: Request captured after /upload</p>

                                <li><p>Who is Info of the C2 Server</p></li>
                                <Table responsive>
                                <tr>
                                    <th><p><strong>Field</strong></p></th>
                                    <th><p><strong>Details</strong></p></th>
                                </tr>
                                <tr>
                                    <th><p>IP Address</p></th>
                                    <th><p>167[.]86[.]97[.]58</p></th>
                                </tr>
                                <tr>
                                    <th><p>Netname</p></th>
                                    <th><p>CONTABO</p></th>
                                </tr>
                                <tr>
                                    <th><p>Organization</p></th>
                                    <th><p>Contabo GmbH</p></th>
                                </tr>
                                <tr>
                                    <th><p>Country</p></th>
                                    <th><p>DE (Germany)</p></th>
                                </tr>
                                <tr>
                                    <th><p>Registration Date</p></th>
                                    <th><p>11/21/2018</p></th>
                                </tr>
                                <tr>
                                    <th><p>Last Modified</p></th>
                                    <th><p>11/21/2018</p></th>
                                </tr>
                                <tr>
                                    <th><p>Registrar</p></th>
                                    <th><p>RIPE NCC</p></th>
                                </tr>
                            </Table>

                            <li><p>IoCs</p></li>
                            <p>167[.]86[.]97[.]58 (Attacker Server IP)</p>
                            <p>0a1ea0e7119e125141792f24eceb62d2 (Hash of a RAT)</p>

                            <li><p>MITRE ATT&CK Tactics and Techniques</p></li>
                            <ul>
                                <li><p>T1082 | System Information Discovery</p></li>
                                <li><p>T1083 | File and Directory Discovery</p></li>
                                <li><p>T1129 | Shared Modules</p></li>
                                <li><p>TA0003 | Persistence</p></li>
                                <li><p>TA0011 | Command and Control</p></li>
                                <li><p>TA0010 | Exfiltration</p></li>
                            </ul>

                            </ol>

                            <h4>Conclusion</h4>
                            <p>The analyzed binary</p>
                            <p>(7129ad4ac19f03d6512d8ea3a4cf3373c52d30a982e4a3bba2a5357bcbdf7314) is a fully functional Remote Access Trojan (RAT) capable of stealth installation, persistent memory execution, dynamic dependency loading, and remote control via a custom C2 protocol. Its ability to run Python code in-memory and exfiltrate sensitive user files, coupled with remote shell capabilities, marks it as a high-threat malware.</p>
                            
                            <p>___________________________________________________________________</p>
                            <p>This article is authored by Sequretek Research Labs.</p>
                        </div>
                    </div>
                </div>
                <ShareUrl
                    details={{ title: 'Analysis of a Remote Access Trojan', url: 'https://www.sequretek.com/resources/blog/Analysis-of-a-Remote-Access-Trojan' }}
                />
                {/* section 3 RELATED RESOURCES */}
                <div className='seq-resources'>
                    <div className={window.innerWidth > 767 ? 'ps-0' : 'ps-3'}>
                        <h4>Related resources</h4>
                        <div className='row ms-0 me-0'>
                            <div className='col-md-12 ps-0'>
                                <div className={window.innerWidth > 767 ? 'row ' : 'row flex-nowrap overflow-auto ms-0'}>
                                    <RelatedResources
                                        page='resources'
                                        type='blog'
                                        title='Analysis of a Remote Access Trojan'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section 4 SCHEDULE DEMO FORM */}
            <div className='seq-forms'>
                <div className='container '>
                    <div className="insurance-partseven">
                        <ScheduleForm
                            bg={'/images/bg-img22.svg'}
                            mobilebg={'/images/bg-img23.png'}
                            page='resources'
                            text={`Don't wait until it's too late. Strengthen your cyber defences today with Sequretek. Contact us to schedule a demo and learn how our cybersecurity solutions can arm your enterprise against evolving threats.`}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
